import { CanAccess, Title } from 'react-admin';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { useDefineAppLocation } from '@react-admin/ra-navigation';
import ClicksByReferrerWidget from './Widget';

export default function ClicksByReferrerPage(): ReactElement {
  useDefineAppLocation('clicks.by_referrer');

  return (
    <>
      <Title title="Clicks By Referrer" />
      <Stack spacing={3} sx={{ mt: 2, mb: 4 }}>
        <CanAccess resource="clicks_by_referrers" action="list">
          <ClicksByReferrerWidget />
        </CanAccess>
      </Stack>
    </>
  );
}
